type Params = Record<string, string | boolean>

const loadingPromises: Record<string, Promise<Event | void> | undefined> = {}

export const loadElementAfterHydration = (elementName: string, params: Params): Promise<Event | void> => {
  const elementSelector = `${elementName}${Object.entries(params)
    .map(([param, value]) => (typeof value === 'string' ? `[${param}="${value}"]` : `[${param}]`))
    .join('')}`

  const existingPromise = loadingPromises[elementSelector]

  if (typeof existingPromise !== 'undefined') {
    return existingPromise
  }

  const createElementPromise = new Promise<Event | void>((resolve, reject) => {
    const element = document.createElement(elementName)

    Object.entries(params).forEach(([param, value]) => {
      ;(element as unknown as Params)[param] = value
    })

    element.onload = resolve
    element.onerror = reject
    document.head.appendChild(element)
  })

  loadingPromises[elementSelector] = createElementPromise

  return createElementPromise
}
